// extracted by mini-css-extract-plugin
export default {"container":"tags-select_container__YNQQG"};